import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-intent-timeline-circle",
  "use": "icon-intent-timeline-circle-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-intent-timeline-circle\">\n<g id=\"icon-intent-timeline-circle_Frame 33924\">\n<circle id=\"icon-intent-timeline-circle_Ellipse 430\" cx=\"8\" cy=\"8\" r=\"4\" fill=\"#2F5FF2\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol